import { Component, OnInit } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Router } from '@angular/router';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { Movie } from 'app/shared/models/class/movie/movie';
import { MovieService } from 'app/shared/services/movie/movie.service';

@Component({
  selector: 'app-ratings',
  templateUrl: './ratings.component.html',
  styleUrls: ['./ratings.component.scss']
})
export class RatingsComponent implements OnInit {
  faChevronLeft = faChevronLeft;
  ratings = 0;
  disturbing = 0;
  listmovies: Movie[]=[];
  detailRate = false;
  detailMovie: Movie = {} as Movie;
  isFilm: boolean = false;
  
  constructor(
    private movieService : MovieService,
    private router: Router) { }

  ngOnInit(): void {
    this.getMovies();
  }

  private getMovies(): void {
    this.movieService.getMovies(this.isFilm).subscribe({
      next: listmovies => {
        this.listmovies = listmovies;
      }
    })
  }
  onChange(ob: MatSlideToggleChange){
    this.isFilm=!this.isFilm;
    this.getMovies();
  }
  goToRate(movie: Movie): void {
    this.router.navigate([`/admin/ratings/${movie.id}`]);
  }

  vote(){
    this.ratings = 0;
    this.disturbing = 0;
  }
}
